import { StandardInput } from "@/components/ui/forms/standardInput"
import { Text } from "@/components/ui/baseUi/text"
import { getFormErrorMessage } from "@/modules/formik/formikUtils"
import { cn } from "@/modules/lib/utils"
import type {
  ExerciseFormikType,
  ExerciseInputKey,
} from "@/modules/sessions/sessionForm/blocks/exerciseBlock/exerciseFormikTypes"
import type { SimpleFormik } from "@/typings/formik"
import { word } from "@modules/core/utils/i18n"

export function ExerciseDurationInput({
  formik,
  className,
  ...props
}: { formik: SimpleFormik<ExerciseFormikType, ExerciseInputKey> } & React.ComponentProps<"div">) {
  return (
    <div className={cn("rounded-2xl bg-surface-foreground px-5 py-6", className)} {...props}>
      <StandardInput
        label={word("sessionForm.exercise.duration.label")}
        getFieldProps={formik.getFieldProps}
        name={"durationInMin"}
        error={getFormErrorMessage("durationInMin", formik)}
        setFieldValue={formik.setFieldValue}
        containerClassName="flex-row items-center"
        inputProps={{
          value: (formik.values.durationInMin ?? 0).toString(),
          type: "number",
          inputMode: "numeric",
          step: 1,
          min: 0,
          placeholder: "0",
          className: "bg-surface-background",
          onChange: (e) => {
            if (e.target.value === "") {
              void formik.setFieldValue("durationInMin", 0)
              return
            }
            if (isNaN(parseInt(e.target.value))) {
              return
            }
            if (parseInt(e.target.value) > 600) {
              void formik.setFieldValue("durationInMin", 600)
            } else {
              void formik.setFieldValue("durationInMin", parseInt(e.target.value))
            }
          },
        }}
      >
        <Text fontStyle="TM">
          {word("global.minute.shortLabel", {
            count: formik.values.durationInMin ?? 1,
          })}
        </Text>
      </StandardInput>
    </div>
  )
}
